import { render, staticRenderFns } from "./vxeTab.vue?vue&type=template&id=22bea080&"
import script from "./vxeTab.vue?vue&type=script&lang=js&"
export * from "./vxeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports